import React from "react";

import { OptionsType, ResponseType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";
import { PopupBody, PopupDetails, PopupListItem } from "types/api/popup";

function usePopupApi() {
    const { get, del, post, put } = useHttpManaged();

    const getAllPopups = React.useCallback(
        (queryParams: AdvancedListRequest, options?: OptionsType): ResponseType<ListResponse<PopupListItem>> => {
            return get<undefined, AdvancedListRequest, ListResponse<PopupListItem>>({
                url: "/popup",
                queryParams: queryParams,
                options: options,
            });
        },
        [get],
    );

    const getOnePopup = React.useCallback(
        (pathParams: PathParamsWithId, options?: OptionsType): ResponseType<PopupDetails> => {
            return get<PathParamsWithId, undefined, PopupDetails>({
                url: "/popup/:id",
                pathParams: pathParams,
                options: options,
            });
        },
        [get],
    );

    const createPopup = React.useCallback(
        (body: PopupBody, options?: OptionsType): ResponseType<ResponseWithId> => {
            return post<undefined, undefined, PopupBody, ResponseWithId>({
                url: "/popup",
                body: body,
                options: options,
            });
        },
        [post],
    );

    const updatePopup = React.useCallback(
        (pathParams: PathParamsWithId, body: PopupBody, options?: OptionsType): ResponseType<null> => {
            return put<PathParamsWithId, undefined, PopupBody, null>({
                url: "/popup/:id",
                pathParams: pathParams,
                body: body,
                options: options,
            });
        },
        [put],
    );

    const deletePopup = React.useCallback(
        (pathParams: PathParamsWithId, options?: OptionsType): ResponseType<null> => {
            return del<PathParamsWithId, undefined, null>({
                url: "/popup/:id",
                pathParams: pathParams,
                options: options,
            });
        },
        [del],
    );

    return {
        getAllPopups,
        getOnePopup,
        createPopup,
        updatePopup,
        deletePopup,
    };
}

export default usePopupApi;
